import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=0bde1d2e&scoped=true&"
import script from "./RightColumn.vue?vue&type=script&lang=js&"
export * from "./RightColumn.vue?vue&type=script&lang=js&"
import style0 from "./RightColumn.vue?vue&type=style&index=0&id=0bde1d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde1d2e",
  null
  
)

export default component.exports